/** Musical parameter surface — application-owned allowlist over Vital. */
export const PARAM_NAMES = [
    // Voice
    "polyphony",
    "voice_mode",
    "voice_transpose",
    "glide_time",
    "glide_force",
    // Oscillators
    "osc1_level",
    "osc2_level",
    "osc3_level",
    "osc1_transpose",
    "osc2_transpose",
    "osc3_transpose",
    "osc1_tune",
    "osc2_tune",
    "osc3_tune",
    "osc1_pan",
    "osc2_pan",
    "osc3_pan",
    "osc1_phase",
    "osc2_phase",
    "osc3_phase",
    "osc1_random_phase",
    "osc2_random_phase",
    "osc3_random_phase",
    "osc1_unison_voices",
    "osc2_unison_voices",
    "osc3_unison_voices",
    "osc1_unison_detune",
    "osc2_unison_detune",
    "osc3_unison_detune",
    "osc1_unison_blend",
    "osc2_unison_blend",
    "osc3_unison_blend",
    "osc1_stereo_spread",
    "osc2_stereo_spread",
    "osc3_stereo_spread",
    "osc1_frame_spread",
    "osc2_frame_spread",
    "osc3_frame_spread",
    "osc1_wave_frame",
    "osc2_wave_frame",
    "osc3_wave_frame",
    "osc1_spectral_morph_amount",
    "osc2_spectral_morph_amount",
    "osc3_spectral_morph_amount",
    "osc1_phase_distortion_amount",
    "osc2_phase_distortion_amount",
    "osc3_phase_distortion_amount",
    "osc1_destination_filter",
    "osc2_destination_filter",
    "osc3_destination_filter",
    // Sub
    "sub_on",
    "sub_level",
    "sub_transpose",
    "sub_pan",
    "sub_waveform",
    "sub_destination_filter",
    // Filter
    "filter_cutoff",
    "filter_resonance",
    "filter_blend",
    "filter_on",
    "filter_drive",
    "filter_keytrack",
    "filter_mix",
    "filter_model",
    "filter_style",
    "filter_osc1_input",
    "filter_osc2_input",
    "filter_osc3_input",
    "filter_sample_input",
    // Envelopes 1–4
    "env1_delay",
    "env1_attack",
    "env1_hold",
    "env1_decay",
    "env1_sustain",
    "env1_release",
    "env1_attack_power",
    "env1_decay_power",
    "env1_release_power",
    "env2_delay",
    "env2_attack",
    "env2_hold",
    "env2_decay",
    "env2_sustain",
    "env2_release",
    "env2_attack_power",
    "env2_decay_power",
    "env2_release_power",
    "env3_delay",
    "env3_attack",
    "env3_hold",
    "env3_decay",
    "env3_sustain",
    "env3_release",
    "env3_attack_power",
    "env3_decay_power",
    "env3_release_power",
    "env4_delay",
    "env4_attack",
    "env4_hold",
    "env4_decay",
    "env4_sustain",
    "env4_release",
    "env4_attack_power",
    "env4_decay_power",
    "env4_release_power",
    // LFO free rates (Hz) — timing mode lives on modulators
    "lfo1_frequency",
    "lfo2_frequency",
    "lfo3_frequency",
    "lfo4_frequency",
    "lfo5_frequency",
    "lfo6_frequency",
    "lfo7_frequency",
    "lfo8_frequency",
    // Macros values
    "macro_control_1",
    "macro_control_2",
    "macro_control_3",
    "macro_control_4",
    // Output
    "volume",
    // Effects
    "delay_on",
    "delay_dry_wet",
    "delay_feedback",
    "delay_tempo",
    "reverb_on",
    "reverb_dry_wet",
    "reverb_decay",
    "reverb_size",
    "chorus_on",
    "chorus_dry_wet",
    "chorus_depth",
    "chorus_feedback",
    "phaser_on",
    "phaser_dry_wet",
    "phaser_depth",
    "phaser_feedback",
    "flanger_on",
    "flanger_dry_wet",
    "flanger_depth",
    "flanger_feedback",
    "distortion_on",
    "distortion_drive",
    "distortion_mix",
    "compressor_on",
    "compressor_mix",
    "compressor_attack",
    "compressor_release",
];
export const PARAM_RANGES = {
    polyphony: { min: 1, max: 32, default: 8 },
    voice_mode: { min: 0, max: 2, default: 0 }, // 0 poly, 1 mono, 2 legato
    voice_transpose: { min: -48, max: 48, default: 0 },
    glide_time: { min: 0, max: 2, default: 0 },
    glide_force: { min: 0, max: 1, default: 0 },
    osc1_level: { min: 0, max: 1, default: 0.7 },
    osc2_level: { min: 0, max: 1, default: 0 },
    osc3_level: { min: 0, max: 1, default: 0 },
    osc1_transpose: { min: -48, max: 48, default: 0 },
    osc2_transpose: { min: -48, max: 48, default: 0 },
    osc3_transpose: { min: -48, max: 48, default: 0 },
    osc1_tune: { min: -1, max: 1, default: 0 },
    osc2_tune: { min: -1, max: 1, default: 0 },
    osc3_tune: { min: -1, max: 1, default: 0 },
    osc1_pan: { min: -1, max: 1, default: 0 },
    osc2_pan: { min: -1, max: 1, default: 0 },
    osc3_pan: { min: -1, max: 1, default: 0 },
    osc1_phase: { min: 0, max: 1, default: 0 },
    osc2_phase: { min: 0, max: 1, default: 0 },
    osc3_phase: { min: 0, max: 1, default: 0 },
    osc1_random_phase: { min: 0, max: 1, default: 0 },
    osc2_random_phase: { min: 0, max: 1, default: 0 },
    osc3_random_phase: { min: 0, max: 1, default: 0 },
    osc1_unison_voices: { min: 1, max: 16, default: 1 },
    osc2_unison_voices: { min: 1, max: 16, default: 1 },
    osc3_unison_voices: { min: 1, max: 16, default: 1 },
    osc1_unison_detune: { min: 0, max: 1, default: 0.2 },
    osc2_unison_detune: { min: 0, max: 1, default: 0.2 },
    osc3_unison_detune: { min: 0, max: 1, default: 0.2 },
    osc1_unison_blend: { min: 0, max: 1, default: 0.8 },
    osc2_unison_blend: { min: 0, max: 1, default: 0.8 },
    osc3_unison_blend: { min: 0, max: 1, default: 0.8 },
    osc1_stereo_spread: { min: 0, max: 1, default: 0.5 },
    osc2_stereo_spread: { min: 0, max: 1, default: 0.5 },
    osc3_stereo_spread: { min: 0, max: 1, default: 0.5 },
    osc1_frame_spread: { min: 0, max: 1, default: 0 },
    osc2_frame_spread: { min: 0, max: 1, default: 0 },
    osc3_frame_spread: { min: 0, max: 1, default: 0 },
    osc1_wave_frame: { min: 0, max: 256, default: 0 },
    osc2_wave_frame: { min: 0, max: 256, default: 0 },
    osc3_wave_frame: { min: 0, max: 256, default: 0 },
    osc1_spectral_morph_amount: { min: 0, max: 1, default: 0 },
    osc2_spectral_morph_amount: { min: 0, max: 1, default: 0 },
    osc3_spectral_morph_amount: { min: 0, max: 1, default: 0 },
    osc1_phase_distortion_amount: { min: 0, max: 1, default: 0 },
    osc2_phase_distortion_amount: { min: 0, max: 1, default: 0 },
    osc3_phase_distortion_amount: { min: 0, max: 1, default: 0 },
    osc1_destination_filter: { min: 0, max: 1, default: 1 },
    osc2_destination_filter: { min: 0, max: 1, default: 1 },
    osc3_destination_filter: { min: 0, max: 1, default: 1 },
    sub_on: { min: 0, max: 1, default: 0 },
    sub_level: { min: 0, max: 1, default: 0.5 },
    sub_transpose: { min: -24, max: 24, default: -12 },
    sub_pan: { min: -1, max: 1, default: 0 },
    sub_waveform: { min: 0, max: 4, default: 0 }, // sine/triangle/saw/square/noise indexes
    sub_destination_filter: { min: 0, max: 1, default: 1 },
    filter_cutoff: { min: 8, max: 20000, default: 8000 },
    filter_resonance: { min: 0, max: 1, default: 0.1 },
    filter_blend: { min: 0, max: 2, default: 0 },
    filter_on: { min: 0, max: 1, default: 1 },
    filter_drive: { min: 0, max: 1, default: 0 },
    filter_keytrack: { min: 0, max: 1, default: 0 },
    filter_mix: { min: 0, max: 1, default: 1 },
    filter_model: { min: 0, max: 5, default: 0 },
    filter_style: { min: 0, max: 3, default: 0 },
    filter_osc1_input: { min: 0, max: 1, default: 1 },
    filter_osc2_input: { min: 0, max: 1, default: 0 },
    filter_osc3_input: { min: 0, max: 1, default: 0 },
    filter_sample_input: { min: 0, max: 1, default: 0 },
    env1_delay: { min: 0, max: 2.5, default: 0 },
    env1_attack: { min: 0, max: 2.5, default: 0.01 },
    env1_hold: { min: 0, max: 2.5, default: 0 },
    env1_decay: { min: 0, max: 2.5, default: 0.3 },
    env1_sustain: { min: 0, max: 1, default: 0.7 },
    env1_release: { min: 0, max: 5, default: 0.4 },
    env1_attack_power: { min: -10, max: 10, default: 0 },
    env1_decay_power: { min: -10, max: 10, default: 0 },
    env1_release_power: { min: -10, max: 10, default: 0 },
    env2_delay: { min: 0, max: 2.5, default: 0 },
    env2_attack: { min: 0, max: 2.5, default: 0.05 },
    env2_hold: { min: 0, max: 2.5, default: 0 },
    env2_decay: { min: 0, max: 2.5, default: 0.4 },
    env2_sustain: { min: 0, max: 1, default: 0 },
    env2_release: { min: 0, max: 5, default: 0.3 },
    env2_attack_power: { min: -10, max: 10, default: 0 },
    env2_decay_power: { min: -10, max: 10, default: 0 },
    env2_release_power: { min: -10, max: 10, default: 0 },
    env3_delay: { min: 0, max: 2.5, default: 0 },
    env3_attack: { min: 0, max: 2.5, default: 0.05 },
    env3_hold: { min: 0, max: 2.5, default: 0 },
    env3_decay: { min: 0, max: 2.5, default: 0.4 },
    env3_sustain: { min: 0, max: 1, default: 0 },
    env3_release: { min: 0, max: 5, default: 0.3 },
    env3_attack_power: { min: -10, max: 10, default: 0 },
    env3_decay_power: { min: -10, max: 10, default: 0 },
    env3_release_power: { min: -10, max: 10, default: 0 },
    env4_delay: { min: 0, max: 2.5, default: 0 },
    env4_attack: { min: 0, max: 2.5, default: 0.05 },
    env4_hold: { min: 0, max: 2.5, default: 0 },
    env4_decay: { min: 0, max: 2.5, default: 0.4 },
    env4_sustain: { min: 0, max: 1, default: 0 },
    env4_release: { min: 0, max: 5, default: 0.3 },
    env4_attack_power: { min: -10, max: 10, default: 0 },
    env4_decay_power: { min: -10, max: 10, default: 0 },
    env4_release_power: { min: -10, max: 10, default: 0 },
    lfo1_frequency: { min: 0.01, max: 20, default: 1 },
    lfo2_frequency: { min: 0.01, max: 20, default: 2 },
    lfo3_frequency: { min: 0.01, max: 20, default: 0.5 },
    lfo4_frequency: { min: 0.01, max: 20, default: 4 },
    lfo5_frequency: { min: 0.01, max: 20, default: 1 },
    lfo6_frequency: { min: 0.01, max: 20, default: 1 },
    lfo7_frequency: { min: 0.01, max: 20, default: 1 },
    lfo8_frequency: { min: 0.01, max: 20, default: 1 },
    macro_control_1: { min: 0, max: 1, default: 0 },
    macro_control_2: { min: 0, max: 1, default: 0 },
    macro_control_3: { min: 0, max: 1, default: 0 },
    macro_control_4: { min: 0, max: 1, default: 0 },
    volume: { min: 0, max: 1, default: 0.6 },
    delay_on: { min: 0, max: 1, default: 0 },
    delay_dry_wet: { min: 0, max: 1, default: 0.3 },
    delay_feedback: { min: 0, max: 0.95, default: 0.4 },
    delay_tempo: { min: 0, max: 12, default: 9 },
    reverb_on: { min: 0, max: 1, default: 0 },
    reverb_dry_wet: { min: 0, max: 1, default: 0.25 },
    reverb_decay: { min: 0.1, max: 30, default: 1.5 },
    reverb_size: { min: 0, max: 1, default: 0.5 },
    chorus_on: { min: 0, max: 1, default: 0 },
    chorus_dry_wet: { min: 0, max: 1, default: 0.3 },
    chorus_depth: { min: 0, max: 1, default: 0.35 },
    chorus_feedback: { min: 0, max: 0.9, default: 0.2 },
    phaser_on: { min: 0, max: 1, default: 0 },
    phaser_dry_wet: { min: 0, max: 1, default: 0.35 },
    phaser_depth: { min: 0, max: 1, default: 0.4 },
    phaser_feedback: { min: 0, max: 0.9, default: 0.25 },
    flanger_on: { min: 0, max: 1, default: 0 },
    flanger_dry_wet: { min: 0, max: 1, default: 0.3 },
    flanger_depth: { min: 0, max: 1, default: 0.4 },
    flanger_feedback: { min: 0, max: 0.9, default: 0.3 },
    distortion_on: { min: 0, max: 1, default: 0 },
    distortion_drive: { min: 0, max: 1, default: 0.35 },
    distortion_mix: { min: 0, max: 1, default: 0.5 },
    compressor_on: { min: 0, max: 1, default: 0 },
    compressor_mix: { min: 0, max: 1, default: 0.5 },
    compressor_attack: { min: 0, max: 1, default: 0.2 },
    compressor_release: { min: 0, max: 1, default: 0.4 },
};
function p(label, description, extras = { step: 0.01 }) {
    return { label, description, ...extras };
}
export const PARAM_PRESENTATION = {
    polyphony: p("Polyphony", "How many notes may overlap at once.", {
        unit: "voices",
        step: 1,
        integer: true,
    }),
    voice_mode: p("Voice mode", "0 = poly, 1 = mono, 2 = legato.", {
        step: 1,
        integer: true,
    }),
    voice_transpose: p("Voice transpose", "Global pitch offset for the whole voice.", {
        unit: "st",
        step: 1,
        integer: true,
    }),
    glide_time: p("Glide time", "How long pitch takes to travel between notes.", {
        unit: "s",
        step: 0.001,
    }),
    glide_force: p("Glide force", "Whether glide always applies or only on legato.", {
        step: 1,
        boolean: true,
    }),
    osc1_level: p("Osc 1 Level", "Blend of oscillator 1 into the mix."),
    osc2_level: p("Osc 2 Level", "Blend of oscillator 2 into the mix."),
    osc3_level: p("Osc 3 Level", "Blend of oscillator 3 into the mix."),
    osc1_transpose: p("Osc 1 Transpose", "Coarse pitch offset for oscillator 1.", {
        unit: "st",
        step: 1,
        integer: true,
    }),
    osc2_transpose: p("Osc 2 Transpose", "Coarse pitch offset for oscillator 2.", {
        unit: "st",
        step: 1,
        integer: true,
    }),
    osc3_transpose: p("Osc 3 Transpose", "Coarse pitch offset for oscillator 3.", {
        unit: "st",
        step: 1,
        integer: true,
    }),
    osc1_tune: p("Osc 1 Tune", "Fine pitch offset in cents (±100).", { unit: "cents", step: 0.01 }),
    osc2_tune: p("Osc 2 Tune", "Fine pitch offset in cents (±100).", { unit: "cents", step: 0.01 }),
    osc3_tune: p("Osc 3 Tune", "Fine pitch offset in cents (±100).", { unit: "cents", step: 0.01 }),
    osc1_pan: p("Osc 1 Pan", "Stereo placement for oscillator 1."),
    osc2_pan: p("Osc 2 Pan", "Stereo placement for oscillator 2."),
    osc3_pan: p("Osc 3 Pan", "Stereo placement for oscillator 3."),
    osc1_phase: p("Osc 1 Phase", "Starting phase for repeated notes."),
    osc2_phase: p("Osc 2 Phase", "Starting phase for repeated notes."),
    osc3_phase: p("Osc 3 Phase", "Starting phase for repeated notes."),
    osc1_random_phase: p("Osc 1 Random phase", "Randomize phase each note for softer attacks."),
    osc2_random_phase: p("Osc 2 Random phase", "Randomize phase each note for softer attacks."),
    osc3_random_phase: p("Osc 3 Random phase", "Randomize phase each note for softer attacks."),
    osc1_unison_voices: p("Osc 1 Unison", "Stacked voices for width and density.", {
        unit: "voices",
        step: 1,
        integer: true,
    }),
    osc2_unison_voices: p("Osc 2 Unison", "Stacked voices for width and density.", {
        unit: "voices",
        step: 1,
        integer: true,
    }),
    osc3_unison_voices: p("Osc 3 Unison", "Stacked voices for width and density.", {
        unit: "voices",
        step: 1,
        integer: true,
    }),
    osc1_unison_detune: p("Osc 1 Detune", "How far unison voices spread in pitch."),
    osc2_unison_detune: p("Osc 2 Detune", "How far unison voices spread in pitch."),
    osc3_unison_detune: p("Osc 3 Detune", "How far unison voices spread in pitch."),
    osc1_unison_blend: p("Osc 1 Unison blend", "Center vs outer unison voice balance."),
    osc2_unison_blend: p("Osc 2 Unison blend", "Center vs outer unison voice balance."),
    osc3_unison_blend: p("Osc 3 Unison blend", "Center vs outer unison voice balance."),
    osc1_stereo_spread: p("Osc 1 Stereo spread", "Left/right width of unison voices."),
    osc2_stereo_spread: p("Osc 2 Stereo spread", "Left/right width of unison voices."),
    osc3_stereo_spread: p("Osc 3 Stereo spread", "Left/right width of unison voices."),
    osc1_frame_spread: p("Osc 1 Frame spread", "Wavetable-position spread across unison voices."),
    osc2_frame_spread: p("Osc 2 Frame spread", "Wavetable-position spread across unison voices."),
    osc3_frame_spread: p("Osc 3 Frame spread", "Wavetable-position spread across unison voices."),
    osc1_wave_frame: p("Osc 1 Wave Frame", "Wavetable position along the table.", {
        step: 1,
        integer: true,
    }),
    osc2_wave_frame: p("Osc 2 Wave Frame", "Wavetable position along the table.", {
        step: 1,
        integer: true,
    }),
    osc3_wave_frame: p("Osc 3 Wave Frame", "Wavetable position along the table.", {
        step: 1,
        integer: true,
    }),
    osc1_spectral_morph_amount: p("Osc 1 Spectral morph", "Amount of spectral morphing."),
    osc2_spectral_morph_amount: p("Osc 2 Spectral morph", "Amount of spectral morphing."),
    osc3_spectral_morph_amount: p("Osc 3 Spectral morph", "Amount of spectral morphing."),
    osc1_phase_distortion_amount: p("Osc 1 Phase distortion", "Amount of phase distortion."),
    osc2_phase_distortion_amount: p("Osc 2 Phase distortion", "Amount of phase distortion."),
    osc3_phase_distortion_amount: p("Osc 3 Phase distortion", "Amount of phase distortion."),
    osc1_destination_filter: p("Osc 1 → filter", "Route oscillator 1 into the main filter.", {
        step: 1,
        boolean: true,
    }),
    osc2_destination_filter: p("Osc 2 → filter", "Route oscillator 2 into the main filter.", {
        step: 1,
        boolean: true,
    }),
    osc3_destination_filter: p("Osc 3 → filter", "Route oscillator 3 into the main filter.", {
        step: 1,
        boolean: true,
    }),
    sub_on: p("Sub", "Enable the dedicated sub oscillator.", { step: 1, boolean: true }),
    sub_level: p("Sub level", "Loudness of the sub oscillator."),
    sub_transpose: p("Sub transpose", "Pitch of the sub relative to the note.", {
        unit: "st",
        step: 1,
        integer: true,
    }),
    sub_pan: p("Sub pan", "Stereo placement of the sub."),
    sub_waveform: p("Sub waveform", "0 sine, 1 triangle, 2 saw, 3 square, 4 noise.", {
        step: 1,
        integer: true,
    }),
    sub_destination_filter: p("Sub → filter", "Route the sub into the main filter.", {
        step: 1,
        boolean: true,
    }),
    filter_cutoff: p("Cutoff", "Bright/dark boundary of the filter.", {
        unit: "Hz",
        step: 1,
        scale: "log",
    }),
    filter_resonance: p("Resonance", "Emphasis at the cutoff boundary."),
    filter_blend: p("Filter blend", "Morph between low-pass, band-pass, and high-pass character."),
    filter_on: p("Filter", "Enable the main filter.", { step: 1, boolean: true }),
    filter_drive: p("Filter drive", "Saturation and density before/inside the filter."),
    filter_keytrack: p("Filter key track", "How cutoff follows keyboard pitch."),
    filter_mix: p("Filter mix", "Dry/wet balance through the filter."),
    filter_model: p("Filter model", "Indexed filter model/style family.", {
        step: 1,
        integer: true,
    }),
    filter_style: p("Filter style", "Slope/blend style within the selected model.", {
        step: 1,
        integer: true,
    }),
    filter_osc1_input: p("Filter osc 1 in", "Accept oscillator 1 into the filter.", {
        step: 1,
        boolean: true,
    }),
    filter_osc2_input: p("Filter osc 2 in", "Accept oscillator 2 into the filter.", {
        step: 1,
        boolean: true,
    }),
    filter_osc3_input: p("Filter osc 3 in", "Accept oscillator 3 into the filter.", {
        step: 1,
        boolean: true,
    }),
    filter_sample_input: p("Filter sample in", "Accept the sample lane into the filter.", {
        step: 1,
        boolean: true,
    }),
    env1_delay: p("Env 1 Delay", "Wait before the amplitude envelope starts.", { unit: "s", step: 0.001 }),
    env1_attack: p("Env 1 Attack", "How quickly the sound blooms in.", { unit: "s", step: 0.001 }),
    env1_hold: p("Env 1 Hold", "Time spent at peak before decay.", { unit: "s", step: 0.001 }),
    env1_decay: p("Env 1 Decay", "Time from peak down to sustain.", { unit: "s", step: 0.001 }),
    env1_sustain: p("Env 1 Sustain", "Level held while the note remains down."),
    env1_release: p("Env 1 Release", "Tail after note-off.", { unit: "s", step: 0.001 }),
    env1_attack_power: p("Env 1 Attack curve", "Shape of the attack segment."),
    env1_decay_power: p("Env 1 Decay curve", "Shape of the decay segment."),
    env1_release_power: p("Env 1 Release curve", "Shape of the release segment."),
    env2_delay: p("Env 2 Delay", "Wait before modulation envelope 2 starts.", { unit: "s", step: 0.001 }),
    env2_attack: p("Env 2 Attack", "Attack of modulation envelope 2.", { unit: "s", step: 0.001 }),
    env2_hold: p("Env 2 Hold", "Hold of modulation envelope 2.", { unit: "s", step: 0.001 }),
    env2_decay: p("Env 2 Decay", "Decay of modulation envelope 2.", { unit: "s", step: 0.001 }),
    env2_sustain: p("Env 2 Sustain", "Sustain of modulation envelope 2."),
    env2_release: p("Env 2 Release", "Release of modulation envelope 2.", { unit: "s", step: 0.001 }),
    env2_attack_power: p("Env 2 Attack curve", "Shape of envelope 2 attack."),
    env2_decay_power: p("Env 2 Decay curve", "Shape of envelope 2 decay."),
    env2_release_power: p("Env 2 Release curve", "Shape of envelope 2 release."),
    env3_delay: p("Env 3 Delay", "Wait before modulation envelope 3 starts.", { unit: "s", step: 0.001 }),
    env3_attack: p("Env 3 Attack", "Attack of modulation envelope 3.", { unit: "s", step: 0.001 }),
    env3_hold: p("Env 3 Hold", "Hold of modulation envelope 3.", { unit: "s", step: 0.001 }),
    env3_decay: p("Env 3 Decay", "Decay of modulation envelope 3.", { unit: "s", step: 0.001 }),
    env3_sustain: p("Env 3 Sustain", "Sustain of modulation envelope 3."),
    env3_release: p("Env 3 Release", "Release of modulation envelope 3.", { unit: "s", step: 0.001 }),
    env3_attack_power: p("Env 3 Attack curve", "Shape of envelope 3 attack."),
    env3_decay_power: p("Env 3 Decay curve", "Shape of envelope 3 decay."),
    env3_release_power: p("Env 3 Release curve", "Shape of envelope 3 release."),
    env4_delay: p("Env 4 Delay", "Wait before modulation envelope 4 starts.", { unit: "s", step: 0.001 }),
    env4_attack: p("Env 4 Attack", "Attack of modulation envelope 4.", { unit: "s", step: 0.001 }),
    env4_hold: p("Env 4 Hold", "Hold of modulation envelope 4.", { unit: "s", step: 0.001 }),
    env4_decay: p("Env 4 Decay", "Decay of modulation envelope 4.", { unit: "s", step: 0.001 }),
    env4_sustain: p("Env 4 Sustain", "Sustain of modulation envelope 4."),
    env4_release: p("Env 4 Release", "Release of modulation envelope 4.", { unit: "s", step: 0.001 }),
    env4_attack_power: p("Env 4 Attack curve", "Shape of envelope 4 attack."),
    env4_decay_power: p("Env 4 Decay curve", "Shape of envelope 4 decay."),
    env4_release_power: p("Env 4 Release curve", "Shape of envelope 4 release."),
    lfo1_frequency: p("LFO 1 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo2_frequency: p("LFO 2 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo3_frequency: p("LFO 3 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo4_frequency: p("LFO 4 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo5_frequency: p("LFO 5 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo6_frequency: p("LFO 6 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo7_frequency: p("LFO 7 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    lfo8_frequency: p("LFO 8 Rate", "Free-running rate when not tempo-synced.", {
        unit: "Hz",
        step: 0.01,
        scale: "log",
    }),
    macro_control_1: p("Macro 1", "Performance control 1 value."),
    macro_control_2: p("Macro 2", "Performance control 2 value."),
    macro_control_3: p("Macro 3", "Performance control 3 value."),
    macro_control_4: p("Macro 4", "Performance control 4 value."),
    volume: p("Volume", "Overall output level."),
    delay_on: p("Delay", "Enable tempo-friendly echoes.", { step: 1, boolean: true }),
    delay_dry_wet: p("Delay Mix", "Wet amount of the delay."),
    delay_feedback: p("Delay Feedback", "How long echoes persist."),
    delay_tempo: p("Delay Tempo", "Synced delay division index.", { step: 1, integer: true }),
    reverb_on: p("Reverb", "Enable space/ambience.", { step: 1, boolean: true }),
    reverb_dry_wet: p("Reverb Mix", "Wet amount of the reverb."),
    reverb_decay: p("Reverb Decay", "How long the space rings.", { unit: "s", step: 0.01 }),
    reverb_size: p("Reverb Size", "Perceived room size."),
    chorus_on: p("Chorus", "Enable chorus width/motion.", { step: 1, boolean: true }),
    chorus_dry_wet: p("Chorus Mix", "Wet amount of the chorus."),
    chorus_depth: p("Chorus Depth", "Modulation depth of the chorus."),
    chorus_feedback: p("Chorus Feedback", "Resonance of the chorus."),
    phaser_on: p("Phaser", "Enable phaser notches.", { step: 1, boolean: true }),
    phaser_dry_wet: p("Phaser Mix", "Wet amount of the phaser."),
    phaser_depth: p("Phaser Depth", "Sweep depth of the phaser."),
    phaser_feedback: p("Phaser Feedback", "Intensity of phaser notches."),
    flanger_on: p("Flanger", "Enable flanger motion.", { step: 1, boolean: true }),
    flanger_dry_wet: p("Flanger Mix", "Wet amount of the flanger."),
    flanger_depth: p("Flanger Depth", "Sweep depth of the flanger."),
    flanger_feedback: p("Flanger Feedback", "Metallic intensity of the flanger."),
    distortion_on: p("Distortion", "Enable harmonic drive.", { step: 1, boolean: true }),
    distortion_drive: p("Distortion Drive", "How hard the signal is driven."),
    distortion_mix: p("Distortion Mix", "Wet amount of distortion."),
    compressor_on: p("Compressor", "Enable density shaping.", { step: 1, boolean: true }),
    compressor_mix: p("Compressor Mix", "Wet amount of compression."),
    compressor_attack: p("Compressor Attack", "How quickly compression engages."),
    compressor_release: p("Compressor Release", "How quickly compression releases."),
};
export const MOD_SOURCES = [
    "lfo_1",
    "lfo_2",
    "lfo_3",
    "lfo_4",
    "lfo_5",
    "lfo_6",
    "lfo_7",
    "lfo_8",
    "env_1",
    "env_2",
    "env_3",
    "env_4",
    "macro_1",
    "macro_2",
    "macro_3",
    "macro_4",
    "note",
    "velocity",
    "aftertouch",
    "mod_wheel",
    "random",
    "stereo_random",
];
export const MOD_DESTINATIONS = [
    "osc_1_level",
    "osc_2_level",
    "osc_3_level",
    "osc_1_transpose",
    "osc_2_transpose",
    "osc_3_transpose",
    "osc_1_pan",
    "osc_2_pan",
    "osc_3_pan",
    "osc_1_wave_frame",
    "osc_2_wave_frame",
    "osc_3_wave_frame",
    "voice_transpose",
    "filter_cutoff",
    "filter_resonance",
    "filter_drive",
    "filter_mix",
    "volume",
    "reverb_dry_wet",
    "delay_dry_wet",
    "chorus_dry_wet",
    "phaser_dry_wet",
    "distortion_drive",
    "macro_control_1",
    "macro_control_2",
    "macro_control_3",
    "macro_control_4",
];
export const SEQUENCE_DESTINATIONS = [
    "voice_transpose",
    "osc_1_level",
    "volume",
    "filter_cutoff",
    "osc_1_wave_frame",
    "osc_2_wave_frame",
    "osc_1_pan",
    "reverb_dry_wet",
    "delay_dry_wet",
];
export const LFO_SHAPES = [
    "sine",
    "triangle",
    "square",
    "saw",
    "random",
    "sample_and_hold",
];
/** Allowlisted tempo divisions (Vital synced-frequency indexes 0–12). */
export const TEMPO_DIVISIONS = [
    "freeze",
    "32/1",
    "16/1",
    "8/1",
    "4/1",
    "2/1",
    "1/1",
    "1/2",
    "1/4",
    "1/8",
    "1/16",
    "1/32",
    "1/64",
];
export const TEMPO_DIVISION_INDEX = {
    freeze: 0,
    "32/1": 1,
    "16/1": 2,
    "8/1": 3,
    "4/1": 4,
    "2/1": 5,
    "1/1": 6,
    "1/2": 7,
    "1/4": 8,
    "1/8": 9,
    "1/16": 10,
    "1/32": 11,
    "1/64": 12,
};
export const PRESET_STYLES = [
    "bass",
    "lead",
    "pad",
    "pluck",
    "keys",
    "fx",
    "perc",
    "sequence",
    "other",
];
export const WAVETABLE_GENERATORS = [
    "sine",
    "triangle",
    "saw",
    "square",
    "pulse",
    "noise",
    "harmonic",
];
export const VOICE_MODES = ["poly", "mono", "legato"];
export function voiceModeToParam(mode) {
    return VOICE_MODES.indexOf(mode);
}
export function paramToVoiceMode(value) {
    const idx = Math.round(value);
    return VOICE_MODES[Math.min(2, Math.max(0, idx))] ?? "poly";
}
//# sourceMappingURL=params.js.map